export default "__VITE_ASSET__DmWtoa1C__"